import React, { Component, Fragment } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import DocumentTable from "./DocumentTable/DocumentTable";
import { ASYNC_STATE } from "assets/scripts/constants/Constants";
import { connect } from "react-redux";
import { loadDocuments, addDocument, addModalChange } from "assets/scripts/domain/document/documentActions";
import keyBy from "lodash/keyBy";
import orderBy from "lodash/orderBy";
import moment from "moment";
import AddDocumentModal from "assets/scripts/components/containers/secure/Documents/AddDocumentModal/AddDocumentModal";
import uid from "assets/scripts/utils/uid";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import styles from "./Documents.module.less";
import WithAccounts from "../WithAccounts/WithAccounts";
import AccountCardWrapper from "assets/scripts/components/presentational/AccountCardWrapper/AccountCardWrapper";
import Pagination from "assets/scripts/components/presentational/Pagination/Pagination";
import flatten from "lodash/flatten";
import track from "react-tracking";
const messages = defineMessages({
    loadError: {
        id: "documents.loadError",
        defaultMessage: "Your documents weren't loaded due to this error:"
    }
});
class Documents extends Component {
    constructor() {
        super(...arguments);
        this._uid = uid();
        this._handleUploadClick = () => {
            this.props.onAddModalChange(true);
        };
        this._handleModalClose = () => {
            this.props.onAddModalChange(false);
        };
    }
    componentDidMount() {
        this._loadCheck(true);
    }
    componentDidUpdate() {
        this._loadCheck();
    }
    _loadCheck(retryError = false) {
        const { loadState } = this.props;
        if (loadState === ASYNC_STATE.NONE
            || (retryError && loadState === ASYNC_STATE.REJECTED)) {
            this.props.onLoad();
        }
    }
    render() {
        const { props } = this;
        return (<WithAccounts>
				{accounts => {
            const loadState = this._getLoadState(accounts);
            const loadError = accounts.error || props.loadError;
            return (<Fragment>
							<div className="wrapper wrapper_mediumPlus">
								<div className={styles.header}>
									<h1 className="hdg js-pageHeader">
										<FormattedMessage id="documents.header" defaultMessage="Documents"/>
									</h1>

									<button className="btn js-modal-btnTrigger" onClick={this._handleUploadClick} disabled={loadState !== ASYNC_STATE.RESOLVED} data-modaltriggerid={this._uid}>
										<FormattedMessage id="documents.upload.button" defaultMessage="Upload"/>
									</button>
								</div>

								<StatusMessage isActive={loadState === ASYNC_STATE.PENDING} isLoad/>

								<StatusMessage isError isActive={loadError != null} error={loadError} customMessage={messages.loadError}/>

								{loadState === ASYNC_STATE.RESOLVED && (<Fragment>
										{props.documents.length === 0 && (<div className="vr vr_x4">
												<div className="text">
													<FormattedMessage tagName="p" id="documents.noDocuments" defaultMessage={("No documents are currently available. {uploadLink} a new "
                + "document to DCM Services, LLC.")} values={{
                uploadLink: (<button type="button" className="link" onClick={this._handleUploadClick}>
																	<FormattedMessage id="documents.noDocuments.uploadLink" defaultMessage="Upload"/>
																</button>)
            }}/>
												</div>
											</div>)}

										{props.documents.length > 0 && (this._renderDocuments(accounts))}
									</Fragment>)}
							</div>
							<AddDocumentModal open={props.addModalOpen} triggerId={this._uid} state={props.addState} error={props.addError} backendErrors={props.addBackendErrors} documentTypes={props.documentTypes} locale={props.locale} onClose={this._handleModalClose} onUpload={this.props.onAdd}/>
						</Fragment>);
        }}
			</WithAccounts>);
    }
    _renderDocuments({ accts }) {
        const { props } = this;
        const documents = this._getSortedDocuments();
        const documentTypes = keyBy(props.documentTypes, it => it.id);
        const accountsById = keyBy(flatten([...accts.deceased, ...accts.live].map(it => it.accounts)), it => it.id);
        const documentsByPayableIdId = {};
        for (const document of documents) {
            for (const payableId of document.payableIds) {
                const docs = documentsByPayableIdId[payableId] || (documentsByPayableIdId[payableId] = []);
                docs.push(document);
            }
        }
        return (<Pagination items={Object.entries(documentsByPayableIdId)} itemsPerPage={3}>
				{({ page, renderPager }) => (<Fragment>
						{page.map(([id, docs]) => {
            const account = accountsById[id];
            return (<AccountCardWrapper key={id} className={styles.card}>
									<AccountCardWrapper.Content>
										<div>
											<AccountCardWrapper.Title group={{
                primary: account,
                accounts: [account]
            }}/>
										</div>

										<AccountCardWrapper.Details refNum={account.refNum} className={styles.details}/>
									</AccountCardWrapper.Content>

									<DocumentTable documents={docs} documentTypes={documentTypes}/>
								</AccountCardWrapper>);
        })}
						{renderPager("Account")}
					</Fragment>)}
			</Pagination>);
    }
    _getLoadState(accounts) {
        if (accounts.loading) {
            return ASYNC_STATE.PENDING;
        }
        if (accounts.error) {
            return ASYNC_STATE.REJECTED;
        }
        return this.props.loadState;
    }
    _getSortedDocuments() {
        const documents = this.props.documents.map(document => ({
            ...document,
            timestamp: moment(document.timestamp)
        }));
        return orderBy(documents, it => it.timestamp.unix(), "desc");
    }
}
export default track({ page: "Documents" }, { dispatchOnMount: true })(connect((state) => ({
    loadState: state.document.loadState,
    loadError: state.document.loadError,
    documents: state.document.documents,
    documentTypes: state.document.documentTypes,
    locale: state.i18n.locale,
    addModalOpen: state.document.addModalOpen,
    addState: state.document.addState,
    addError: state.document.addError,
    addBackendErrors: state.document.backendErrors
}), {
    onLoad: loadDocuments,
    onAddModalChange: addModalChange,
    onAdd: addDocument
})(Documents));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Documents/Documents.tsx